:host {
  position: fixed;
  right: var(--wrapper-horizontal-position, 1rem);
  bottom: 25px;
  z-index: 9998;
}

.wrapper {
  display: flex;
  align-items: stretch; /* changed from center to stretch */
  font-family: inherit;
  box-sizing: border-box;
  padding: 0px 12px;
  flex-direction: column;
  align-items: end;
}

:host([position='left']) {
  right: auto;
  left: 1rem;
}

@media (max-width: 768px) {

  :host {
    right: var(--wrapper-horizontal-position, 1rem);
  }

  :host([position='left'])  {
    left: 1rem;
  }
}


.message-box {
  width: 100%;
  min-width: 12rem; /* Adjust as needed */
  max-width: 18rem;
  padding: 16px;
  height: auto;
  font-size: 12px;
  letter-spacing: -0.03em;
  line-height: 1.5;
  text-align: left;
  display: flex;
  justify-content: center;
  align-items: left;
  flex-grow: 1; 
  flex-direction: column;
  margin-bottom: 2rem;
  border-radius: 16px 16px 16px 16px;
  box-shadow: 0 10px 15px 3px rgba(0, 0, 0, 0.15);
  transition: 150ms;
  transform: translateY(1rem);
  pointer-events: all;
}

.logo-message-wrapper {
  padding: 0px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1; 
  flex-direction: column;
}





:host([position='left']) .wrapper {
  align-items: start;
} 

#whatsapp-link {
  border: 'none'; 
  background: 'none'; 
  padding: 0; 
  cursor: 'pointer' 
}


.powered-by {
  display: flex;
  margin-top: 5px;
  font-size: 10px;
  flex-direction: column;
  flex-direction: row;
}

.logo-button {
  background: none; 
  border: none;       
  cursor: pointer; 
  padding: 0;
  border: none; 
  background-color: transparent;
  display: flex; 
  justify-content: center; 
  align-items: center; 
  width: 50px;
  margin-left: 4px;
}


.logo-button:focus {
  outline: none;
}

.text-cta {
  padding: 8px
}

.cta {
  display: block;
  margin: 1rem 0 0.25rem 0;
  padding: 0.65rem 1rem;
  border-radius: 0.75rem;
  text-align: center;
  text-decoration: none;
  font-weight: bolder;
  backface-visibility: hidden;
  transform: translate3d(0, 0, 0);
  transition: 200ms ease transform;
  transform-origin: 51% 51%;
  cursor: pointer;
  border: 0;
  width: 100%;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  -webkit-animation: breathing 3s ease-out infinite normal;
  animation: breathing 3s ease-out infinite normal;
  -webkit-font-smoothing: antialiased;
}

.paragraph {
  font-size: 16px;
  margin-top: 0px
}

#chat-bubble {
  cursor: pointer;
}

@-webkit-keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    transform: scale(0.9);
  }
}

@keyframes breathing {
  0% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  25% {
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    transform: scale(1);
  }

  60% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }

  100% {
    -webkit-transform: scale(0.9);
    -ms-transform: scale(0.9);
    transform: scale(0.9);
  }
}